import { render, staticRenderFns } from "./SingleUpload.vue?vue&type=template&id=60b94710&scoped=true&"
import script from "./SingleUpload.vue?vue&type=script&lang=js&"
export * from "./SingleUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b94710",
  null
  
)

export default component.exports